export const tr = {
    'esli-u-vas-est-param-link': 'bizi bilgilendirin',
    'operator-comment': 'Operatör yorumu',
    'oshibki-ustraneny-nuzhna-povtornaya-100': 'Hatalar giderildi, reklamın tekrar kontrol edilmesi gerekiyor',
    'ostalis-drugie-voprosy-po': 'Servisle ilgili başka sorularım var',
    'ostalis-voprosy-o-prichinah': 'Reddedilme nedenleriyle ilgili sorularım var',
    'ostavit-zayavku-na-vozvrat': 'Geri ödeme talebi gönder',
    'otpravit-dokumenty': 'Belgeleri gönder',
    'polnyy-spisok-trebovaniy': 'Gereksinimlerin tam listesi',
    'popup-title': 'Nasıl düzeltilmeli',
    'ubedites-chto-reklamnye-materialy':
        'Reklam materyallerinin {yandex} ve {law} ile uyumlu olduğundan emin olun. Görseller, anahtar sözcükler ve hızlı bağlantılar için belirtilmiş koşullara özellikle dikkat edin.',
    'ubedites-chto-reklamnye-materialy-param-law': 'yürürlükteki yasalar',
    'ubedites-chto-reklamnye-materialy-param-yandex': 'Yandex reklam politikası'
};
